import UrlAnalyzer from "@/components/UrlAnalyzer";

export default function EmbedPage() {
  return (
    <div
      className="min-h-screen vx-glow-bg text-white"
      data-testid="embed-page"
    >
      <div className="max-w-2xl mx-auto p-4 sm:p-6">
        <header className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2.5">
            <img
              src="/isotype.jpg"
              alt="IF Detector"
              width={32}
              height={32}
              className="w-8 h-8 rounded-md object-cover ring-1 ring-white/10"
            />
            <div>
              <div className="font-display font-bold tracking-tight text-base leading-none">
                IF Detector
              </div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[--vx-text-dim] font-mono mt-0.5 leading-none">
                Detector de video IA
              </div>
            </div>
          </div>
          <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-[--vx-text-faint] font-mono">
            <span className="w-1.5 h-1.5 rounded-full bg-[--vx-real] vx-blink" />
            Online
          </div>
        </header>

        <div className="text-center mb-6">
          <h1 className="font-display font-black text-2xl sm:text-3xl tracking-tighter">
            ¿IA o real?
          </h1>
          <p className="text-sm text-[--vx-text-dim] mt-2">
            Pega la URL del video y obtén el veredicto en segundos.
          </p>
        </div>

        <UrlAnalyzer compact />

        <p className="mt-8 text-[10px] sm:text-xs text-[--vx-text-faint] font-mono text-center">
          Análisis asistido por IA · Un servicio de Interactiva Films
        </p>
      </div>
    </div>
  );
}
